// extracted by mini-css-extract-plugin
export default {"onlyDark":"NavigationTitle_onlyDark__jKmxo","onlyLight":"NavigationTitle_onlyLight__iGGe3","nav-bar-title":"NavigationTitle_nav-bar-title__u0-u1"};